import { defineNuxtRouteMiddleware } from '#imports'

export default defineNuxtRouteMiddleware((to) => {
  if (!to.path.includes('/select-lens-type')) {
    return
  }

  const stepMap: { [key: string]: string } = {
    '1': 'prescriptionType',
    '2': 'lensSubType',
    '3': 'lensType',
    '4': 'lensIndex',
    '5': 'lensTint',
    '5a': 'photochromicLensTint',
    '6': 'lensCoating',
  }

  const step = to.query.step as string
  if (step && stepMap[step]) {
    to.meta.currentStep = stepMap[step]
  }
})
